module.exports = __webpack_public_path__ + "img/xiaoxue.05977aad.png";